import { COST_ANALYSIS_DIMENSION_KEYS } from 'containers/CloudResourceCost-API/constants';
import { getTabName } from 'containers/CloudResourceCost-API/helper';
import {
  getDimensionDataForCostAllocationTag,
  getDimensionDataForLabels,
  getDimensionDatForTags,
} from 'api/cloud-resource-cost';
import { currencyFormat } from 'utils/number';
import React from 'react';
import { isStringNull } from 'utils/helper';
import { getAvailableCostAllocationValue, getAvailableLabelValue, getAvailableTagValue } from 'api/showback';

export const getDimensionLabel = (type, labelForValue = false, selectedKey = '') => {
  if (type === COST_ANALYSIS_DIMENSION_KEYS.TAGS) {
    if (labelForValue) {
      return `${selectedKey}: untagged`;
    }

    return 'untagged';
  }

  const label = `No ${getTabName(type)}`;

  if (labelForValue) {
    return `${selectedKey}: ${label} value`;
  }

  return label;
};

export const getDimensionKey = type => {
  switch (type) {
    case COST_ANALYSIS_DIMENSION_KEYS.LABELS:
      return 'label';
    case COST_ANALYSIS_DIMENSION_KEYS.COST_ALLOCATION_TAGS:
      return 'cost_allocation_tag';
    case COST_ANALYSIS_DIMENSION_KEYS.TAGS:
      return 'tag';
    default:
      return type;
  }
};

export const getDimensionAction = type => {
  switch (type) {
    case COST_ANALYSIS_DIMENSION_KEYS.LABELS:
      return getDimensionDataForLabels;
    case COST_ANALYSIS_DIMENSION_KEYS.COST_ALLOCATION_TAGS:
      return getDimensionDataForCostAllocationTag;
    default:
      return getDimensionDatForTags;
  }
};

export const getDimensionShowbackAction = type => {
  switch (type) {
    case COST_ANALYSIS_DIMENSION_KEYS.LABELS:
      return getAvailableLabelValue;
    case COST_ANALYSIS_DIMENSION_KEYS.COST_ALLOCATION_TAGS:
      return getAvailableCostAllocationValue;
    default:
      return getAvailableTagValue;
  }
};

export const lockedLabel = (
  label,
  cost,
  dimension,
  fetchAll,
  isFilterLocked,
  labelForValue = false,
  selectedKey = '',
) => {
  const formattedCost = !fetchAll ? `(${currencyFormat(cost)})` : null;

  if (isStringNull(label)) {
    return `${getDimensionLabel(dimension, labelForValue, selectedKey)} ${formattedCost}`;
  }

  if (!isFilterLocked) {
    return `${label} ${formattedCost}`;
  }

  return (
    <>
      {label.slice(0, Math.ceil(label.length / 2))}
      <span className={isFilterLocked ? 'locked' : ''}>
        {label.slice(Math.ceil(label.length / 2))} {formattedCost}
      </span>
    </>
  );
};
